import React from 'react'
import CusActionSvg from 'src/assets/svg/cusAction.svg'
import GptActionSvg from 'src/assets/svg/gptAction.svg'
import InfoSvg from 'src/assets/svg/info.svg'
import ShuchuSvg from 'src/assets/svg/shuchu.svg'
import ShuruSvg from 'src/assets/svg/shuru.svg'

interface SvgIconPropsType {
  type: keyof typeof ICONS_MAP
}

function SvgIcon(props: SvgIconPropsType) {
  const { type } = props

  const renderDom = () => {
    switch (type) {
      case 'input':
        return <ShuruSvg />
      case 'output':
        return <ShuchuSvg />
      case 'LLMAction':
        return <GptActionSvg />
      case 'JavaPluginAction':
        return <CusActionSvg />
      case 'MessageAction':
        return <InfoSvg />
      default:
        break
    }
  }

  return <>{renderDom()}</>
}

export default SvgIcon
